"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStatistics200ResponseToJSON = exports.GetStatistics200ResponseFromJSONTyped = exports.GetStatistics200ResponseFromJSON = exports.instanceOfGetStatistics200Response = void 0;
var runtime_1 = require("../runtime");
var GiveawayAggregatedStatistics_1 = require("./GiveawayAggregatedStatistics");
/**
 * Check if a given object implements the GetStatistics200Response interface.
 */
function instanceOfGetStatistics200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetStatistics200Response = instanceOfGetStatistics200Response;
function GetStatistics200ResponseFromJSON(json) {
    return GetStatistics200ResponseFromJSONTyped(json, false);
}
exports.GetStatistics200ResponseFromJSON = GetStatistics200ResponseFromJSON;
function GetStatistics200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, GiveawayAggregatedStatistics_1.GiveawayAggregatedStatisticsFromJSON)(json['data']),
    };
}
exports.GetStatistics200ResponseFromJSONTyped = GetStatistics200ResponseFromJSONTyped;
function GetStatistics200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, GiveawayAggregatedStatistics_1.GiveawayAggregatedStatisticsToJSON)(value.data),
    };
}
exports.GetStatistics200ResponseToJSON = GetStatistics200ResponseToJSON;
